import { noop } from 'rxjs';
import { NULL_TEXT_EDIT_SERVICE, TextEditService } from '../text/textEditService';

export interface HtmlEditService extends TextEditService {
  insertDirtyHtml(html: string): void;
  insertCleanHtml(html: string): void;
  insertDeferredCleanHtml(callback: () => Promise<string | undefined>): Promise<void>;
}

export const NULL_HTML_EDIT_SERVICE: HtmlEditService = {
  ...NULL_TEXT_EDIT_SERVICE,
  insertDirtyHtml: noop,
  insertCleanHtml: noop,
  insertDeferredCleanHtml: () => Promise.resolve(),
};
